module.exports = __webpack_public_path__ + "img/complaint_filing.7069e345.png";